import basicController from 'servicestack/basic.controller.properties'
import Product from 'emun.shopping/product.model'
import templateUrl from 'emun.stockchecker/stock-checker.htm'
import $session from 'servicestack/session'
import ProductQuery from 'emun.shopping/product-query.service'

class StockCheckerController {
    constructor($rootScope, $state, createAutoQuery, createServiceBus) {
        basicController(this)
        //let options = {
        //    url: 'QueryProducts.json',
        //    orderBy: '-CreatedOn',
        //    autoLoad: true,
        //    append: false,
        //    take: 15,
        //    pageSize: 15,
        //    scrub(response) {
        //        response.data.results = Product.map(response.data.results);
        //    },
        //    criteria: {
        //        status: 'Active'
        //    },
        //    sortOptions: {
        //        'Id': 'Id',
        //        '-Id': 'Id',
        //        'ShortDescription,Id': 'Description',
        //        '-ShortDescription,Id': 'Description',
        //        'Cost,Id': 'Cost',
        //        '-Cost,Id': 'Cost',
        //        'RetailPrice,Id': 'Price',
        //        '-RetailPrice,Id': 'Price',
        //        'CreatedOn,Id': 'Created',
        //        '-CreatedOn,Id': 'Created',
        //        'Status,Id': 'Status',
        //        '-Status,Id': 'Status',
        //    }
        //};
        //this.query = createAutoQuery(options);
        this.bus = createServiceBus($rootScope);
        this.$state = $state;
        this.$session = $session;
    }
//    load() { return this.query.load(); }

    //editProduct(id) {
    //    this.$state.go('products.edit', { productId: id });
    //}
    //viewProduct(id) {
    //    this.$state.go('product.view', { productId: id });
    //}
}

let StockChecker = {
    controller: StockCheckerController,
    templateUrl($element, $attrs) {
        return $attrs.templateUrl || templateUrl
    }
}

angular.module('emun.stockchecker').component('stockChecker', StockChecker);


